import React from 'react';
import {
  ApartmentOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  RocketOutlined,
} from '@ant-design/icons';
import { Card, Col, Row, Statistic } from 'antd';

interface SummaryCardsProps {
  totalProjects: number;
  newJobs: number;
  pendingJobs: number;
  failedJobs: number;
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({
  totalProjects,
  newJobs,
  pendingJobs,
  failedJobs,
}) => (
    <Row gutter={[16, 16]} className='auto-render-dashboard__summary'>
      <Col xs={24} sm={12} md={6}>
        <Card bordered={false} className='summary-card'>
          <Statistic
            title='Projects Impacted'
            value={totalProjects}
            prefix={<ApartmentOutlined />}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card bordered={false} className='summary-card'>
          <Statistic
            title='Jobs in Queue'
            value={newJobs}
            prefix={<RocketOutlined />}
            valueStyle={{ color: '#2f54eb' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card bordered={false} className='summary-card'>
          <Statistic
            title='Rendering Now'
            value={pendingJobs}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card bordered={false} className='summary-card'>
          <Statistic
            title='Failed Jobs'
            value={failedJobs}
            prefix={<ExclamationCircleOutlined />}
            valueStyle={{ color: '#cf1322' }}
          />
        </Card>
      </Col>
    </Row>
  );
